import { type Breakpoint } from '@mui/material/styles';

/**
 * The default MUI breakpoint values.
 */
export const ThemeBreakpoints = {
  lg: 1200,
  md: 900,
  sm: 600,
  xl: 1536,
  xs: 0,
} as const satisfies Record<Breakpoint, number>;

/**
 * A typeguard that indicates whether or not the provided value, {@link unknown}, is valid
 * {@link Breakpoint} - defined by @mui.
 */
export const isBreakpoint = (value: unknown): value is Breakpoint =>
  typeof value === 'string' && Object.keys(ThemeBreakpoints).includes(value);
